var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"#f0f2f5"}},[_c('nav-bar'),_c('div',{staticClass:"inner-container"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }